export const SettingsGroup = {
    DISPLAY_SETTINGS: 10
};